let lastTime = null;
let autoScrollId;
let lastSpeedPxPerSecond = 30;

const startAutoScroll = (speedPxPerSecond = 30, onEnd) => {
    stopAutoScroll();
    lastTime = null;
    lastSpeedPxPerSecond = speedPxPerSecond;

    const scroll = (time) => {
        if (lastTime == null) lastTime = time;

        const delta = (time - lastTime) / 1000;
        lastTime = time;

        const maxScroll =
            document.documentElement.scrollHeight - window.innerHeight;

        if (window.scrollY + 2 >= maxScroll) {
            stopAutoScroll();
            onEnd?.();
            return;
        }

        window.scrollBy(0, speedPxPerSecond * delta);
        autoScrollId = requestAnimationFrame(scroll);
    };

    autoScrollId = requestAnimationFrame(scroll);
};


const stopAutoScroll = () => {
    if (autoScrollId) {
        cancelAnimationFrame(autoScrollId);
        autoScrollId = null;
        lastTime = null;
        return lastSpeedPxPerSecond;
    }
};

export { startAutoScroll, stopAutoScroll };
